import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardCheck, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { listArtifacts } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import ConfidenceMeter from "@/components/ConfidenceMeter";
import ContributorClassTag from "@/components/ContributorClassTag";

export default function Reviews() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    listArtifacts({ status: "in_review" })
      .then((r) => setItems(r.items || []))
      .catch((err) => toast.error(err?.response?.data?.detail || "Failed to load review queue"));
  }, []);
  return (
    <div className="p-8 md:p-10 space-y-6" data-testid="reviews-page">
      <div>
        <div className="tracked-caps">My queue</div>
        <h2 className="mt-1 font-serif-display text-3xl">Reviews</h2>
        <p className="text-sm text-muted-foreground mt-1 max-w-2xl">
          Candidate artifacts awaiting your decision. Every row opens the full review workspace.
        </p>
      </div>

      {items.length === 0 ? (
        <div className="rounded-lg border border-border bg-card p-12 text-center">
          <ClipboardCheck className="h-6 w-6 mx-auto text-muted-foreground" />
          <div className="mt-3 font-serif-display text-xl">Your queue is clear</div>
          <div className="text-sm text-muted-foreground mt-1">New candidates will appear here when extracted.</div>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((a) => (
            <Link to={`/app/artifacts/${a.id}`} key={a.id} className="block rounded-lg border border-border bg-card p-5 hover:shadow-sm transition-all" data-testid={`review-card-${a.id}`}>
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs text-muted-foreground">{a.id}</span>
                <StatusBadge value={a.status} />
              </div>
              <h3 className="mt-2 font-serif-display text-xl leading-snug">{a.title}</h3>
              <div className="text-xs text-muted-foreground mt-1">{a.domain} · {a.type}</div>
              <div className="mt-4 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <ContributorClassTag value={a.contributor_classes[0]} count={a.contributor_count} />
                  <ConfidenceMeter value={a.confidence} />
                </div>
                <span className="inline-flex items-center gap-1 text-xs text-brand">
                  Open workspace <ArrowRight className="h-3 w-3" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
